class ActivationRequiredController {
    static create(params) {
        return new ActivationRequiredController(params);
    }

    constructor({env}) {
        this.env = env;
        this.mainDialog = env.getDialog('user-inactive-dialog');
        this.resentDialog = env.getDialog('activation-email-resent-dialog');

        this.initEvents();
    }

    initEvents() {
        this.env.onNav('userNotActivated', ({email}) => this.show({email}));

        this.mainDialog.on('signInButton:click', () => this.navToSignIn());
        this.mainDialog.on('resendEmailButton:click', () => this.onResendEmailClick());
        this.resentDialog.on('okButton:click', () => this.navToSignIn());
    }

    getEmail() {
        return this.email;
    }

    navToSignIn() {
        this.env.navTo('userSignIn', {email: this.getEmail()});
    }

    onResendEmailClick() {
        this.mainDialog.setSubmitting(true);

        this.env.getProxy().resendActivationEmail({email: this.getEmail()})
            .then(() => {
                this.mainDialog.setSubmitting(false);
                this.resentDialog.show();
            });
    }

    show({email}) {
        this.email = email;
        this.mainDialog.show();
    }
}

export default ActivationRequiredController;